var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9165 3.33325H16.111V4.44436H17.7776V16.6666H2.22209V4.44436H3.88876V3.33325H2.0832C1.95334 3.33542 1.82517 3.36316 1.70602 3.41487C1.58687 3.46658 1.47908 3.54126 1.38879 3.63464C1.29851 3.72801 1.22751 3.83826 1.17984 3.95909C1.13217 4.07991 1.10878 4.20894 1.11098 4.33881V16.7721C1.10878 16.902 1.13217 17.031 1.17984 17.1519C1.22751 17.2727 1.29851 17.3829 1.38879 17.4763C1.47908 17.5697 1.58687 17.6444 1.70602 17.6961C1.82517 17.7478 1.95334 17.7755 2.0832 17.7777H17.9165C18.0464 17.7755 18.1746 17.7478 18.2937 17.6961C18.4129 17.6444 18.5207 17.5697 18.6109 17.4763C18.7012 17.3829 18.7722 17.2727 18.8199 17.1519C18.8676 17.031 18.891 16.902 18.8888 16.7721V4.33881C18.891 4.20894 18.8676 4.07991 18.8199 3.95909C18.7722 3.83826 18.7012 3.72801 18.6109 3.63464C18.5207 3.54126 18.4129 3.46658 18.2937 3.41487C18.1746 3.36316 18.0464 3.33542 17.9165 3.33325Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44434 7.77783H5.55545V8.88894H4.44434V7.77783Z",
    fill: "#858585"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77783 7.77783H8.88894V8.88894H7.77783V7.77783Z",
    fill: "#858585"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1108 7.77783H12.222V8.88894H11.1108V7.77783Z",
    fill: "#858585"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4443 7.77783H15.5554V8.88894H14.4443V7.77783Z",
    fill: "#858585"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44434 10.5557H5.55545V11.6668H4.44434V10.5557Z",
    fill: "#858585"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77783 10.5557H8.88894V11.6668H7.77783V10.5557Z",
    fill: "#858585"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1108 10.5557H12.222V11.6668H11.1108V10.5557Z",
    fill: "#858585"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4443 10.5557H15.5554V11.6668H14.4443V10.5557Z",
    fill: "#858585"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44434 13.3333H5.55545V14.4444H4.44434V13.3333Z",
    fill: "#858585"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77783 13.3333H8.88894V14.4444H7.77783V13.3333Z",
    fill: "#858585"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1108 13.3333H12.222V14.4444H11.1108V13.3333Z",
    fill: "#858585"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4443 13.3333H15.5554V14.4444H14.4443V13.3333Z",
    fill: "#858585"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55556 5.55553C5.7029 5.55553 5.84421 5.497 5.94839 5.39281C6.05258 5.28862 6.11111 5.14732 6.11111 4.99997V1.66664C6.11111 1.5193 6.05258 1.37799 5.94839 1.2738C5.84421 1.16962 5.7029 1.11108 5.55556 1.11108C5.40821 1.11108 5.26691 1.16962 5.16272 1.2738C5.05853 1.37799 5 1.5193 5 1.66664V4.99997C5 5.14732 5.05853 5.28862 5.16272 5.39281C5.26691 5.497 5.40821 5.55553 5.55556 5.55553Z",
    fill: "#858585"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4447 5.55553C14.5921 5.55553 14.7334 5.497 14.8376 5.39281C14.9417 5.28862 15.0003 5.14732 15.0003 4.99997V1.66664C15.0003 1.5193 14.9417 1.37799 14.8376 1.2738C14.7334 1.16962 14.5921 1.11108 14.4447 1.11108C14.2974 1.11108 14.1561 1.16962 14.0519 1.2738C13.9477 1.37799 13.8892 1.5193 13.8892 1.66664V4.99997C13.8892 5.14732 13.9477 5.28862 14.0519 5.39281C14.1561 5.497 14.2974 5.55553 14.4447 5.55553Z",
    fill: "#858585"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22217 3.33325H12.7777V4.44436H7.22217V3.33325Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.ac0e74920ce8aeee4aa06e5ea3d13adb.svg";
export { ForwardRef as ReactComponent };